
import { useEffect, useRef } from "react";
import {useAuth} from "@/provider/AuthProvider";

import { getEcho } from '@/lib/socket/echo';

export default function ReverbChannel({
                                          privateChannel = "",
                                          publicChannel = "",
                                          event,
                                          action,
                                      }) {
    const { user } = useAuth();

    const actionRef = useRef(action);

    useEffect(() => {
        actionRef.current = action;
    }, [action]);

    useEffect(() => {
        if (!user?.id || !event) return;

        if (!privateChannel && !publicChannel) {
            console.error(
                "ReverbChannel: privateChannel or publicChannel is required."
            );
            return;
        }

        if (privateChannel && publicChannel) {
            console.error(
                "ReverbChannel: specify only one channel type."
            );
            return;
        }

        let active = true;
        let channel = null;

        const listener = (payload) => {
            if (active) {
                actionRef.current(payload);
            }
        };

        async function connect() {
            try {


                const echo = getEcho();

                if (!echo || !active) return;

                const subscribedChannel = privateChannel
                    ? echo.private(privateChannel)
                    : echo.channel(publicChannel);

                channel = subscribedChannel;

                subscribedChannel.listen(event, listener);
            } catch (error) {
                console.error("Reverb subscription failed:", error);
            }
        }

        void connect();

        return () => {
            active = false;

            if (channel) {
                channel.stopListening(event, listener);
            }
        };
    }, [user?.id, privateChannel, publicChannel, event]);

    return null;
}